import React, { useEffect, useState, useRef } from 'react';

const CancellationHeroSection = () => {
    const [activeTab, setActiveTab] = useState('support-tab-1');
    const sectionRefs = useRef({});

    const sections = [
        { id: 'support-tab-1', title: 'Purpose and scope' },
        { id: 'support-tab-2', title: 'Free trial offer' },
        { id: 'support-tab-3', title: 'Subscription activation and payment terms' },
        { id: 'support-tab-4', title: 'Subscription renewal and automatic billing' },
        { id: 'support-tab-5', title: 'Cancellation policy ' },
        { id: 'support-tab-6', title: 'Refund policy' },
        { id: 'support-tab-7', title: 'Termination' },
        { id: 'support-tab-8', title: 'Data retention and deletion' },
        { id: 'support-tab-9', title: 'Policy amendments' },
        { id: 'support-tab-10', title: 'Governing law and jurisdiction' },
        { id: 'support-tab-11', title: 'Contact and grievance redressal' },
        { id: 'support-tab-11', title: 'Acceptance of policy' },

    ];

    // Observe sections on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveTab(entry.target.id);
                    }
                });
            },
            { threshold: 0.5 }
        );

        sections.forEach((section) => {
            if (sectionRefs.current[section.id]) {
                observer.observe(sectionRefs.current[section.id]);
            }
        });

        return () => {
            sections.forEach((section) => {
                if (sectionRefs.current[section.id]) {
                    observer.unobserve(sectionRefs.current[section.id]);
                }
            });
        };
    }, []);

    // Smooth scroll on click
    const handleClick = (id) => {
        const element = sectionRefs.current[id];
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="support-content pb-60">
            <div className="container">
                <div className="row justify-content-between">
                    {/* Sidebar */}
                    <div className="col-lg-4 col-md-4 d-none d-md-block d-lg-block">
                        <div className="support-article-sidebar sticky-sidebar">
                            <div className="nav flex-column nav-pills support-article-tab bg-light rounded-custom p-4">
                                {sections.map((section) => (
                                    <button
                                        key={section.id}
                                        className={`nav-link text-start fw-bold ${activeTab === section.id ? 'active' : ''
                                            }`}
                                        onClick={() => handleClick(section.id)}
                                    >
                                        {section.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-lg-7 col-md-8">
                        <div>
                            {/* Section 1 */}
                            <div
                                id="support-tab-1"
                                ref={(el) => (sectionRefs.current['support-tab-1'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Purpose and scope</h4>
                                <p>This cancellation and refund policy (“policy”) sets forth the terms and procedures regarding subscription cancellations and refund eligibility for users (“user,” “you,” or “your”) of our software as a service (“SaaS”) app. This policy applies to all subscription plans and related services offered by us and is binding upon registration, subscription, or usage of the apps. By accessing or subscribing to our apps, you acknowledge you’re understanding and acceptance of this policy.</p>

                            </div>

                            {/* Section 2 */}
                            <div
                                id="support-tab-2"
                                ref={(el) => (sectionRefs.current['support-tab-2'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Free trial offer</h4>
                                <ol>
                                    <li>We provide a complimentary, one-time free trial of fifteen (15) calendar days to all new users, commencing on the date of successful account registration.</li>
                                    <li>During the trial period, users are granted full access to the app’s standard features in accordance with the selected plan, subject to applicable terms of service.</li>
                                    <li>No payment or billing information is required to activate the trial unless specifically indicated at registration.</li>
                                    <li>Upon expiration of the free trial, continued use of the app requires conversion to a paid subscription and completion of the required payment.</li>
                                    <li>Trial access is one-time only, per user or entity, unless otherwise agreed in writing.</li>
                                </ol>

                            </div>

                            {/* Section 3 */}
                            <div
                                id="support-tab-3"
                                ref={(el) => (sectionRefs.current['support-tab-3'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Subscription activation and payment terms</h4>
                                <p>
                                    Paid subscriptions become active immediately upon successful payment receipt via authorised payment methods, including UPI, net banking, debit/credit cards, or approved payment gateways. All subscription charges, including applicable taxes (such as goods and services tax), must be paid in advance and are non-refundable & non-transferable.

                                </p><p>
                                    Invoices and receipts shall be provided to users in compliance with Indian taxation laws and may be accessed via the app dashboard or upon request. By completing payment, users agree to abide by our Terms of Service, Privacy Policy, and this cancellation and refund policy.
                                </p>

                            </div>

                            {/* Section 4 */}
                            <div
                                id="support-tab-4"
                                ref={(el) => (sectionRefs.current['support-tab-4'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Subscription renewal and automatic billing</h4>
                                <ol>
                                    <li>Subscriptions may be configured for automatic renewal in accordance with the terms selected at purchase, to ensure uninterrupted service.
                                    </li>
                                    <li>Automatic billing will be processed using the payment method on file at the end of each billing cycle unless the user cancels at least twenty-four (24) hours before renewal.</li>
                                    <li>The company shall notify users in advance, via email or dashboard notification, of upcoming renewals and associated charges.
                                    </li>
                                    <li>Users can manage or disable automatic renewals via their account settings or by contacting customer support.
                                    </li>
                                    <li>No refunds shall be issued for renewal payments once processed, except in cases of proven billing error as defined in section 7.
                                    </li>
                                </ol>
                            </div>


                            {/* Section 5 */}
                            <div
                                id="support-tab-5"
                                ref={(el) => (sectionRefs.current['support-tab-5'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Cancellation policy
                                </h4>
                                <ol>
                                    <li>Users may initiate cancellation of their subscription at any time through the app’s account dashboard or by submitting a written request to our support team at the contact email address.</li>
                                    <li>Cancellations made during the free trial incur no charges, and the account will be deactivated immediately upon request.
                                    </li>
                                    <li>For paid subscriptions, cancellation takes effect at the end of the current billing cycle. Users retain access to paid app features through the paid period’s end.
                                    </li>
                                    <li>No cancellation fees apply; however, no partial, pro-rated, or full refunds will be issued for unused portions of subscription terms after cancellation.
                                    </li>
                                    <li>Upon cancellation, users are encouraged to export or back up personal and business data, as data deletion will occur as per section 8.</li>

                                </ol>

                            </div>

                            {/* Section 6 */}
                            <div
                                id="support-tab-6"
                                ref={(el) => (sectionRefs.current['support-tab-6'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Refund policy
                                </h4>
                                <ol>
                                    <li>All payments made towards subscriptions, add-ons, integrations, setup fees, and renewals are final, non-refundable, and non-transferable, barring statutory exceptions under Indian law.</li>
                                    <li>No refunds shall be provided for user-initiated cancellations, dissatisfaction, accidental purchases, non-usage, or changes in business requirements.
                                    </li>
                                    <li>Refunds will only be considered in cases of documented billing errors caused solely by the app, such as duplicate charges or incorrect debits. In such events, users must notify the company in writing within seven (7) days of the disputed transaction, providing supporting evidence.
                                    </li>
                                    <li>Upon validation of a billing error, the company will process a refund or adjustment within ninety (90) business days, in accordance with applicable legal requirements.
                                    </li>
                                    <li>All other payment disputes arising from third-party payment processors, banks, or financial institutions should be directed to the respective party. The company is not responsible for delays or errors beyond its control.</li>

                                </ol>
                            </div>


                            {/* Section 7 */}
                            <div
                                id="support-tab-7"
                                ref={(el) => (sectionRefs.current['support-tab-7'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Termination
                                </h4>
                               <ol>
                                <li>The company reserves the right to suspend or terminate a user’s account, with or without prior notice, for violations of the terms of service, acceptable use policy, or applicable law.</li>
                                <li>Termination for cause does not entitle the user to any refund or credit for the remaining subscription term.</li>
                                <li>Severe or repeated violations may result in permanent banishment from the app.</li>
                               </ol>
                            </div>


                            {/* Section 8 */}
                            <div
                                id="support-tab-8"
                                ref={(el) => (sectionRefs.current['support-tab-8'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Data retention and deletion
                                </h4>
                                <ol>
                                    <li>Upon cancellation or termination, user data will be retained for a period specified in our data retention policy and in accordance with the Information Technology Act, 2000 and allied data protection regulations.</li>
                                    <li>Data will be securely deleted or anonymised after the retention period unless retention is mandated by law.</li>
                                    <li>Users may request data export before account closure or expiry of the retention period by contacting support.</li>
                                    <li>The company employs industry-standard security protocols for data protection and deletion.</li>
                                </ol>

                            </div>


                            {/* Section 9 */}
                            <div
                                id="support-tab-9"
                                ref={(el) => (sectionRefs.current['support-tab-9'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4>
                                    Policy amendments
                                </h4>
                              <ol>
                                <li>The company reserves the right to update, revise, or amend this policy at its sole discretion to reflect changes in business processes, legal requirements, or regulatory guidance.</li>
                                <li>Material amendments will be communicated to users via registered email or app alerts at least seven (7) days before the effective date.</li>
                                <li>Continued usage of the app following such changes constitutes acceptance of the revised policy.</li>
                              </ol>
                            </div>

                            <ol start="10">
                              </ol>


                            {/* Section 10 */}
                            <div
                                id="support-tab-10"
                                ref={(el) => (sectionRefs.current['support-tab-10'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Governing law and jurisdiction
                                </h4>
                        <ol>
                                <li>This policy, and any disputes arising therefrom, shall be governed and construed in accordance with the laws of the Republic of India.</li>
                                <li>All disputes are subject to the exclusive jurisdiction of the courts located in Jaipur, Rajasthan (India).</li>
                        </ol>

                            </div>


                            {/* Section 11 */}
                            <div
                                id="support-tab-11"
                                ref={(el) => (sectionRefs.current['support-tab-11'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Contact and grievance redressal
                                </h4>
                                <ol>
                                    <li>For clarifications, grievances, or legal notices pertaining to this policy, users may contact our designated grievance officer at our contact email available on our website under the ‘help’ or ‘contact us’ section.</li>
                                    <li>All concerns will be acknowledged within forty-eight (48) working hours and resolved in accordance with applicable statutory timelines.</li>
                                    <li>The contact information for support and grievance redressal is available on our website under the ‘help’ or ‘contact us’ section.</li>
                                </ol>
                            </div>

                             {/* Section 12 */}
                            <div
                                id="support-tab-12"
                                ref={(el) => (sectionRefs.current['support-tab-12'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Acceptance of policy
                                </h4>
                                <ol>
                                    <li>By registering for, subscribing to, or using any Senertech app, you confirm that you have read, understood, and agree to be bound by this cancellation and refund policy, as well as all other related terms and policies. If you do not agree with any provision herein, please refrain from subscribing to or using our services.</li>
                                    <li>This policy is in full compliance with the laws and regulations of India and is designed to ensure clarity, fairness, and transparency for all users of our SaaS apps.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CancellationHeroSection;

